import React, {
  useState,
  useEffect,
  useContext,
  MouseEvent,
  ReactNode,
} from "react";
import { useRef, MutableRefObject } from "react";
import { StyleClass } from "primereact/styleclass";
import { Ripple } from "primereact/ripple";
import { Button } from "primereact/button";
import LanguageContext from "../../components/Language/LanguageContext";

// Define types for props and context
interface NavbarProps {
  onTopbarMenuButtonClick: () => void;
  onTopbarHide: () => void;
}

interface LanguageContextType {
  language: string;
  messages: {
    home: string;
    products: string;
    ApplicationPurpose: string;
    Featured: string;
    pricing: string;
    contact: string;
    Benefit: string;
  };
  changeLanguage: (lang: string) => void;
}

const Navbar = (props: NavbarProps) => {
  // Create refs compatible with StyleClass component
  const menuButtonRef = useRef<HTMLButtonElement>(null);
  const btnRef1 = useRef<any>(null);
  const btnRef2 = useRef<any>(null);
  const mobileMenuRef = useRef<HTMLDivElement>(null);

  const [selectedOption, setselectedOption] = useState<string | null>(null);
  const { language, messages, changeLanguage } = useContext(LanguageContext);
  const [selectedLanguage, setSelectedLanguage] = useState<string>("ID");
  const [isDropdownVisible, setIsDropdownVisible] = useState<boolean>(false);
  const [isClient, setIsClient] = useState<boolean>(false);
  const [mobileMenuVisible, setMobileMenuVisible] = useState<boolean>(false);
  // Tambahkan state untuk kontrol menu products
  const [productsMenuVisible, setProductsMenuVisible] =
    useState<boolean>(false);

  interface Option {
    label: string;
    value: string;
  }

  const options: Option[] = [
    { label: "Goal", value: "/goal" },
    { label: "Invest", value: "/invest" },
  ];

  const onOptionChange = (e: { value: string }) => {
    setselectedOption(e.value); // Update state with selected route
    window.location.href = e.value; // Navigate to selected route using window.location
  };

  const onTopbarMenuButtonClick = () => {
    props.onTopbarMenuButtonClick();
  };

  const onTopbarHide = () => {
    props.onTopbarHide();
  };

  // Function for smooth scrolling to target element
  const handleSmoothScroll = (
    event: MouseEvent<HTMLAnchorElement>,
    sectionId: string
  ) => {
    event.preventDefault();
    const section = document.querySelector(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
    // Close mobile menu after navigation
    setMobileMenuVisible(false);
    setIsDropdownVisible(false);
    setProductsMenuVisible(false); // Tutup menu products setelah navigasi
  };

  const handleLanguageChange = (newLang: string) => {
    setSelectedLanguage(newLang);
    changeLanguage(newLang);
    setIsDropdownVisible(false);
  };

  const toggleMobileMenu = () => {
    setMobileMenuVisible(!mobileMenuVisible);
    // Close language dropdown when toggling mobile menu
    setIsDropdownVisible(false);
  };

  // Toggle products menu
  const toggleProductsMenu = () => {
    setProductsMenuVisible(!productsMenuVisible);
  };

  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    <>
      <div
        className="surface py-3 px-5 shadow-2 flex align-items-center justify-content-between fixed top-0 w-full z-50"
        style={{
          zIndex: "999",
          backgroundColor: "#115c9f",
        }}
      >
        <a href="#home" onClick={(e) => handleSmoothScroll(e, "#home")}>
          <img
            src="/images/Navbar/fixLogo.png"
            alt="Image"
            style={{ height: "40px" }}
          />
        </a>

        {/* Mobile menu button */}
        <button
          className="p-ripple cursor-pointer block lg:hidden text-700 border-none bg-transparent"
          onClick={toggleMobileMenu}
          ref={menuButtonRef}
          style={{ color: "white" }}
        >
          <i className="pi pi-bars text-4xl" style={{ color: "white" }}></i>
          <Ripple />
        </button>

        <div
          ref={mobileMenuRef}
          className={`align-items-center flex-grow-1 justify-content-between ${
            mobileMenuVisible ? "flex" : "hidden"
          } lg:flex absolute lg:static surface left-0 top-100 z-5 shadow-2 lg:shadow-none navs`}
          style={{ backgroundColor: "#115c9f" }}
        >
          <section></section>
          <ul className="list-none p-0 m-0 flex lg:align-items-center text-900 select-none flex-column lg:flex-row cursor-pointer navss2">
            <li>
              <a
                href="#home"
                onClick={(e) => handleSmoothScroll(e, "#home")}
                className="p-ripple flex px-3 lg:px-5 py-3 font-medium transition-colors transition-duration-150 no-underline navvvvv"
              >
                <span style={{ fontFamily: "Poppins" }}>{messages.home}</span>
                <Ripple />
              </a>
            </li>
            <li className="relative">
              {/* Ganti dengan button yang toggle state productsMenuVisible */}
              <a
                className="p-ripple flex px-3 lg:px-5 py-3 align-items-center font-medium transition-colors transition-duration-150 navvvvv"
                onClick={toggleProductsMenu}
                style={{ textDecoration: "none" }}
              >
                <span
                  style={{
                    fontFamily: "Poppins",
                    zIndex: "9999",
                  }}
                >
                  {messages.products}
                </span>
                <i
                  className={`pi ${
                    productsMenuVisible ? "pi-chevron-up" : "pi-chevron-down"
                  } ml-auto lg:ml-3 navvvvv chev`}
                ></i>
                <Ripple />
              </a>

              {/* Tambahkan kondisi untuk menampilkan menu dropdown */}
              {productsMenuVisible && (
                <ul
                  className="lg:shadow-2 lg:absolute origin-top w-full lg:w-10rem"
                  style={{
                    borderRadius: "5px",
                    overflow: "hidden",
                    backgroundColor: "white",
                  }}
                >
                  <li className="lang-option">
                    <a
                      href="#product"
                      onClick={(e) => handleSmoothScroll(e, "#product")}
                      className="p-ripple flex px-3 lg:px-2 hover:text-blue-600 font-medium transition-colors transition-duration-550 no-underline mt-2"
                      style={{ color: "black" }}
                    >
                      <span style={{ fontFamily: "Poppins" }}>
                        {messages.products}
                      </span>
                      <Ripple />
                    </a>
                  </li>
                  <li className="lang-option">
                    <a
                      href="#features"
                      onClick={(e) => handleSmoothScroll(e, "#features")}
                      className="p-ripple flex px-3 lg:px-2 hover:text-blue-600 font-medium transition-colors transition-duration-150 no-underline"
                      style={{ color: "black" }}
                    >
                      <span style={{ fontFamily: "Poppins" }}>
                        {messages.ApplicationPurpose}
                      </span>
                      <Ripple />
                    </a>
                  </li>
                  <li className="lang-option">
                    <a
                      href="#benefit"
                      onClick={(e) => handleSmoothScroll(e, "#benefit")}
                      className="p-ripple flex px-3 lg:px-2 hover:text-blue-600 font-medium transition-colors transition-duration-150 no-underline mb-2"
                      style={{ color: "black" }}
                    >
                      <span style={{ fontFamily: "Poppins" }}>
                        {messages.Featured}
                      </span>
                      <Ripple />
                    </a>
                  </li>
                </ul>
              )}
            </li>
            <li>
              <a
                href="#pricing"
                onClick={(e) => handleSmoothScroll(e, "#pricing")}
                className="p-ripple flex px-3 lg:px-5 py-3 font-medium transition-colors transition-duration-150 no-underline navvvvv"
              >
                <span style={{ fontFamily: "Poppins" }}>
                  {messages.pricing}
                </span>
                <Ripple />
              </a>
            </li>
            <li>
              <a
                href="#contact"
                onClick={(e) => handleSmoothScroll(e, "#contact")}
                className="p-ripple flex px-3 lg:px-5 py-3 font-medium transition-colors transition-duration-150 no-underline navvvvv"
              >
                <span style={{ fontFamily: "Poppins" }}>
                  {messages.contact}
                </span>
                <Ripple />
              </a>
            </li>
          </ul>

          {/* Language and login buttons container */}
          <div className="flex align-items-center flex-column lg:flex-row justify-content-between px-3 mobile-auth-container">
            {/* Language Dropdown Selector */}
            <div className="flex align-items-center relative mb-3 lg:mb-0 mobile-lang-selector">
              <div
                className="flex align-items-center cursor-pointer test2"
                onClick={() => setIsDropdownVisible(!isDropdownVisible)}
              >
                <i className="pi pi-globe mr-2 navvvvv"></i>
                <span className="navvvvv">{language.toUpperCase()}</span>
                <i className="pi pi-chevron-down ml-1 navvvvv mr-3"></i>
              </div>

              {isDropdownVisible && (
                <ul
                  className="absolute top-full left-0 mt-3 w-36 bg-white rounded-md shadow-lg z-[1000] list-none "
                  style={{
                    listStyleType: "none",
                    zIndex: 1000,
                  }}
                >
                  <li
                    className="lang-option"
                    onClick={() => handleLanguageChange("ID")}
                  >
                    Indonesian
                  </li>
                  <li
                    className="lang-option"
                    onClick={() => handleLanguageChange("EN")}
                  >
                    English
                  </li>
                </ul>
              )}
            </div>

            {/* Log In and Sign Up Buttons - Invisible but still taking space */}
            <div className="flex flex-column lg:flex-row singup mobile-buttons-container">
              <a
                href="https://app.smartsafetee.com/"
                className="block lg:inline-block w-full lg:w-auto rounded-lg border border-white bg-transparent px-4 py-2 text-center hover:bg-white-800 transition-all"
                style={{marginLeft:'7px'}}
              >
                <Button
                  icon="pi pi-sign-in"
                  label="Log in"
                  className="font-bold text-[#115c9f] w-full"
                  style={{
                    color: "white",
                    border: "none",
                    padding: 0,
                  }}
                />
              </a>
              {/* <a
                href="https://app.smartsafetee.com/auth/registration"
                className="block lg:inline-block w-full lg:w-auto rounded-lg border border-white bg-white px-4 py-2 text-center hover:bg-white-800 transition-all"
                style={{marginLeft:'7px'}}
              >
                <Button
                  label="Sign Up For Free"
                  className="font-bold text-[#115c9f] w-full"
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    padding: 0,
                  }}
                />
              </a> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
